// src/pages/atributos/EditarValorAtributo.js
import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

function EditarValorAtributo({ mostrar, valor, guardar, cancelar }) {
    const [nombre, setNombre] = useState('')
    const [activo, setActivo] = useState(true)
    const [errores, setErrores] = useState({})
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (valor && mostrar) {
            setNombre(valor.nombre || '')
            setActivo(valor.activo)
        }
    }, [valor, mostrar])

    const handleClose = () => {
        setErrores({})
        cancelar()
    }

    const validar = () => {
        const nuevosErrores = {}

        if (!nombre.trim()) {
            nuevosErrores.nombre = 'El nombre es obligatorio'
        }

        setErrores(nuevosErrores)
        return Object.keys(nuevosErrores).length === 0
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!validar()) return

        setLoading(true)

        try {
            await guardar({
                nombre: nombre.trim(),
                activo
            })
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    if (!valor) return null

    return (
        <Modal show={mostrar} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fa fa-pencil text-primary me-2"></i>
                    Editar valor
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="nombre">
                        <Form.Label>Nombre *</Form.Label>
                        <Form.Control
                            type="text"
                            value={nombre}
                            onChange={(e) => setNombre(e.target.value)}
                            placeholder="Nombre del valor..."
                            isInvalid={!!errores.nombre}
                            autoFocus
                        />
                        <Form.Control.Feedback type="invalid">
                            {errores.nombre}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="activo">
                        <Form.Check
                            type="switch"
                            label="Activo"
                            checked={activo}
                            onChange={(e) => setActivo(e.target.checked)}
                        />
                        <Form.Text className="text-muted">
                            Los valores inactivos no aparecerán como opción en productos
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={handleClose} disabled={loading}>
                        Cancelar
                    </Button>
                    <Button variant="primary" type="submit" disabled={loading}>
                        {loading ? (
                            <>
                                <i className="fa fa-spinner fa-spin me-2"></i>
                                Guardando...
                            </>
                        ) : (
                            <>
                                <i className="fa fa-save me-2"></i>
                                Guardar cambios
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

export default EditarValorAtributo